// extracted by mini-css-extract-plugin
export default {"img":"As8tgI_deW4SRSRbaRgS","body":"cmwOKsJ6U2Y2k3apiN2O","bodyItem":"QTnLLmL8JedWNdM3FpTG","btn":"yG1_gBb5hV6t2X2e9zJg"};